import http from '../../../Utils/http';
import responseMessageHandler from '../../../Utils/ResponseMessageHandler';

const UploadDisplayFile = {
  name: 'uploadDisplayFile',
  state: {
    loading: false,
    error: '',
    success: false,
  },
  reducers: {
    uploadRequested(state) {
      return {
        ...state,
        loading: true,
        error: '',
        success: false,
      };
    },

    uploadSuccess(state) {
      return {
        ...state,
        loading: false,
        error: '',
        success: true,
      };
    },

    uploadFailed(state, payload) {
      return {
        ...state,
        loading: false,
        error: payload,
        success: false,
      };
    },
  },
  effects: (dispatch) => ({
    async uploadExcel({ file, org_id }) {
      try {
        this.uploadRequested();
        // Prepare form data
        const formData = new FormData();
        formData.append('file', file);
        formData.append('org_id', org_id);

        // Send POST request to the API
        const response = await http.post('savvy/displays/upload-excel', formData, {
          headers: {
            'Content-Type': 'multipart/form-data',
          },
        });

        if (response.status === 200) {
          this.uploadSuccess();
          dispatch({
            type: 'helper/show',
            payload: {
              type: 'success',
              message: 'File uploaded successfully!',
              show: true,
            },
          });
        } else {
          throw new Error(response.data.message || 'File upload failed');
        }
      } catch (err) {
        this.uploadFailed(err.message);
        dispatch({
          type: 'helper/show',
          payload: {
            type: 'error',
            message: responseMessageHandler.show(err.message),
            show: true,
          },
        });
      }
    },
  }),
};

export default UploadDisplayFile;
